"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextMenuHeading = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const use_t_1 = require("use-t");
const MiniTitle_1 = require("../../../3-list-item/MiniTitle");
const Arrow_1 = tslib_1.__importDefault(require("../../../icons/interactive/Arrow"));
const Ripple_1 = require("../../../misc/Ripple");
const context_1 = require("../../../styles/context");
const blockClass = (0, nano_theme_1.rule)({
    d: 'block',
    pad: '10px 22px 4px',
});
const compactClass = (0, nano_theme_1.rule)({
    d: 'flex',
    ai: 'center',
    pad: '10px 22px 8px',
});
const interactiveClass = (0, nano_theme_1.rule)({
    bd: 0,
    bg: 'transparent',
    w: '100%',
    ta: 'inherit',
    mar: 0,
    out: 'none',
    pos: 'relative',
    isolation: 'isolate',
    WebkitTapHighlightColor: 'transparent',
    '&:focus': { out: 'none' },
    '&:before': {
        content: '""',
        pos: 'absolute',
        top: 0,
        right: '2px',
        bottom: 0,
        left: '2px',
        bdrad: '4px',
        bg: 'transparent',
        trs: 'background .12s, box-shadow .12s',
        pe: 'none',
        z: -1,
    },
    '&:hover:before': {
        bg: 'rgba(127,127,127,0.06)',
    },
    '&:active:before': {
        bg: 'rgba(127,127,127,0.1)',
    },
    '&:focus:not(:focus-visible):before': {
        bxsh: 'none',
    },
    '&:focus-visible:before': {
        bxsh: '0 0 0 2px rgba(0,137,255,0.6)',
    },
});
const chevronClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    ai: 'center',
    jc: 'center',
    w: '14px',
    h: '14px',
    flexShrink: 0,
    marginInlineStart: '-4px',
});
const ContextMenuHeading = ({ item, compact, collapsed, onToggle }) => {
    const [t] = (0, use_t_1.useT)();
    const styles = (0, context_1.useStyles)();
    const label = item.display?.() ?? t(item.name);
    const collapsible = !!item.collapsible && !!onToggle;
    const titleStyle = item.danger ? { color: styles.col.get('error') } : undefined;
    if (!compact) {
        return (React.createElement("div", { className: blockClass, role: "presentation" },
            React.createElement(MiniTitle_1.MiniTitle, { style: titleStyle }, label)));
    }
    const inner = (React.createElement(React.Fragment, null,
        collapsible && (React.createElement("span", { className: chevronClass },
            React.createElement(Arrow_1.default, { direction: collapsed ? 'r' : 'd', style: { width: 12, height: 12 } }))),
        React.createElement(MiniTitle_1.MiniTitle, { style: { marginInlineStart: 'auto', ...titleStyle } }, label)));
    if (collapsible) {
        return (React.createElement(Ripple_1.Ripple, null,
            React.createElement("button", { type: "button", className: compactClass + interactiveClass, "aria-expanded": !collapsed, onClick: onToggle }, inner)));
    }
    return (React.createElement("div", { className: compactClass, role: "presentation" }, inner));
};
exports.ContextMenuHeading = ContextMenuHeading;
